import React from 'react';
import styleable from 'react-styleable';

import css from './activity-mastery-legends.scss';

import ActivityMasteryKeyLegends from '../../../../components/activity-mastery-key-legends/activity-mastery-key-legends';

const ActivityMasteryLegends = () => (
    <div className={css['report-container']}>
        <div className={css.legends}>
            <ActivityMasteryKeyLegends />
        </div>
    </div>
);

export default styleable(css)(ActivityMasteryLegends);



// WEBPACK FOOTER //
// ./containers/activity-mastery/common/activity-mastery-legends/activity-mastery-legends.js